// Sensei/client/ui/SenseiOnboardingWizard.js
import { ComponentBase } from "../../core/ComponentBase.js";
import StudentProfileSchema from "../../../schemas/collections/studentProfiles.js";

export class SenseiOnboardingWizard extends ComponentBase {
    constructor(config) {
        super(config);
        this.dataWizard = null; // This will hold the DataWizard instance
        this._boundHandleSubmit = this.handleWizardSubmit.bind(this);
    }

    async initialize() {
        await super.initialize();
        // The main logic is now in onShow to ensure it runs every time the view is displayed
    }

    async refresh() {
        await this.setupWizard();
    }


        async setupWizard() {
        if (this.dataWizard) {
            this.dataWizard.off('submit', this._boundHandleSubmit);
            this.dataWizard.destroy();
            this.dataWizard = null;
        }

        const wizardSteps = [
            {
                title: 'Welcome',
                component: 'DataForm',
                componentConfig: {
                    bodyTemplate: `
                        <div class="text-center p-4">
                            <i class="bi bi-mortarboard-fill display-3 text-primary mb-3"></i>
                            <h3>Welcome to Sensei!</h3>
                            <p class="lead text-muted">Let's get your profile set up with a few quick questions to personalize your learning journey.</p>
                        </div>
                    `,
                    fields: {}
                }
            },
            {
                title: 'Your Details',
                component: 'DataForm',
                componentConfig: {
                    schema: StudentProfileSchema.pick({ parentName: true, school: true, dob: true }),
                    fields: {
                        parentName: { type: 'text', label: "Parent's Full Name", required: true },
                        school: { type: 'text', label: 'School Name', required: true },
                        dob: { type: 'date', label: 'Date of Birth', required: true }
                    }
                }
            },
            {
                title: 'Contact Info',
                component: 'DataForm',
                componentConfig: {
                    schema: StudentProfileSchema.pick({ phoneNumber: true }),
                    fields: {
                        phoneNumber: { type: 'tel', label: 'Your Phone Number', required: true, description: "Used for important notifications and account recovery." }
                    }
                }
            }
        ];

        const wizardConfig = {
            instanceId: 'sensei-onboarding-wizard',
            title: 'Getting Started',
            schema: StudentProfileSchema,
            steps: wizardSteps,
            saveToLocalStorage: true,
        };

        this.dataWizard = await this.createManagedComponent(
            "DataWizard",
            this.container,
            wizardConfig
        );

        this.dataWizard.on('submit', this._boundHandleSubmit);
    }


    async handleWizardSubmit(wizardData) {
        try {
            await this.appClient.rpcClient.call('OnboardingRpc.saveOnboardingData', { data: wizardData });

            this.dataWizard.clearState(); // Clear local storage on success

            const onboardingConfig = this.appClient.sessionTokenHandler.getClientConfig().onboarding;
            this.appClient.layoutEngine.navigate(onboardingConfig.completionRedirectRoute);

        } catch (error) {
            this.appClient.notifier.error("Could not save your information. Please try again.");
            this.log.error("Onboarding submission failed:", error);
        }
    }

    render() {
        if (!this.container) {
            this.container = document.createElement('div');
            this.container.className = 'h-100';
        }
        // The container is now just a placeholder. The actual content
        // is created and appended in onShow/setupWizard.
        return this.container;
    }

    destroy() {
        if (this.dataWizard) {
            this.dataWizard.off('submit', this._boundHandleSubmit);
            this.dataWizard.destroy();
            this.dataWizard = null;
        }
        super.destroy();
    }
}